import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/resinContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-charcoal-950 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-132" data-mp="1bmllx5jgptjf">
      <div className="mx-auto max-w-2xl px-5" data-id="element-133" data-mp="1gjvid559r5gr">
        <h2 id="faq-title" className="text-center font-display text-2xl font-semibold uppercase leading-tight text-ivory-50 sm:text-4xl" data-id="element-134" data-mp="248o8gkz7mj3g">
          Frequently asked questions
        </h2>

        <ul className="mt-9 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-135" data-mp="1uibq8zevb20h">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-136" data-mp="2n7sdzjrjluqd" data-mpi={i}>
                <h3 data-id="element-137" data-mp="2n6r25d2pd47l">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-4 text-left" data-id="element-138" data-mp="2n67jfu58absi">
                    <span className="font-display text-lg leading-snug text-ivory-50 sm:text-xl" data-id="element-139" data-mp="1eln0o27hrceb">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-champagne transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-140" data-mp="19sk73u2ps2y4" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-141" data-mp="1sm68b881ogfy">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-142" data-mp="36zt1riadm11">
                      <p className="pb-5 text-[14px] leading-relaxed text-body" data-id="element-143" data-mp="2867tnnpofddf">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}